import type { CreditPlan, CreditPlanResponse } from '../types';

export const mapCreditPlan = (data: CreditPlanResponse): CreditPlan => {
  return {
    id: data.id,
    planId: data.plan_id,
    sku: data.sku,
    name: data.name,
    isActive: data.is_active,
    renewalDate: data.renewal_date,
    renewalPeriod: data.renewal_period,
    price: data.price,
    creditsGranted: data.credits_granted,
    expiresAt: data?.expires_at,
    canceledAt: data?.canceled_at,
    isTrialActive: data.is_trial_active,
    trialPeriodEndsAt: data.trial_period_ends_at,
    trialCreditsGranted: data.trial_credits_granted,
  };
};
